import axios from 'axios'
import configService from './config'
import store from '@/store'
import router from '@/router'

const esriService = axios.create({
  baseURL: configService.apiUrl,
  withCredentials: true,
  xsrfHeaderName: 'X-CSRFToken',
})

esriService.interceptors.request.use(
  config => {
    let token = store.state.auth.access
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    if (
      /^(post|put|patch|delete)$/.test(config.method) &&
      store.getters['auth/userIsAuthenticated']
    ) {
      config['xsrfCookieName'] = 'csrftoken'
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

esriService.interceptors.response.use(
  response => {
    // Return a successful response back to the calling service
    return response
  },
  error => {
    function logoutAndRefresh() {
      store.dispatch('auth/logOut').then(() => {
        store.commit('setError403', false)
        window.location.href = router.currentRoute.path
      })
    }

    // Handle any error which is not due to authentication
    if (!error.response || error.response.status !== 401) {
      if (error.response.status === 403) {
        store.commit('setError403', true)
      } else if (error.response.status === 500) {
        store.commit('setError500', true)
      }
      return Promise.reject(error)
    }

    // Set wrongCredentials if error comes from login page
    if (error.config.url === process.env.VUE_APP_ACCESS_TOKEN_URL) {
      store.commit('auth/updatePassword', '')
      store.commit('auth/setWrongPassword', true)
      return Promise.reject(error)

      // Logout user if token refresh didn't work
    } else if (error.config.url === process.env.VUE_APP_REFRESH_TOKEN_URL) {
      logoutAndRefresh()
      return Promise.reject(error)
    }

    // Try request again with new token
    const refresh = store.state.auth.refresh
    return store
      .dispatch('auth/refreshToken', refresh)
      .then(token => {
        if (token) {
          // New request with new token only if we have a new one
          const config = error.config
          config.headers['Authorization'] = `Bearer ${token}`

          return new Promise((resolve, reject) => {
            esriService
              .request(config)
              .then(res => {
                resolve(res)
              })
              .catch(error => {
                reject(error)
              })
          })
        }
      })
      .catch(error => {
        Promise.reject(error)
      })
  }
)

export default esriService
